import { Row, Select } from 'antd';
import { FormLabel } from 'components/UI/FormLabel';
import { Field, FieldProps } from 'formik';
import { CSSProperties, FC } from 'react';

interface Props {
  fieldName: string;
  type?: string;
  label: string;
  labelStyle?: CSSProperties;
  readOnly?: boolean;
  disabled?: boolean;
  options: string[];
}

export const FieldInputSelect: FC<Props> = ({ fieldName, type, label, labelStyle, readOnly = false, disabled = false, options }) => {
  return (
    <Field name={fieldName}>
      {({
        field, // { name, value, onChange, onBlur }
        form: { setFieldTouched, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta
      }: FieldProps): JSX.Element => (
        <Row style={{ width: '100%' }}>
          <FormLabel style={labelStyle} label={label} />

          <Select
            {...field}
            allowClear
            filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
            onChange={(val): void => setFieldValue(fieldName, val)}
            disabled={disabled}
            status={meta.error && meta.touched ? 'error' : undefined}
            onFocus={(): void => setFieldTouched(fieldName, false)}
            style={{ width: '100%' }}
            options={options.map((option) => ({ label: option, value: option }))}
          />
          <div className={meta.touched && meta.error ? 'field-error-show' : 'field-error-hide'}>{meta.error}</div>
        </Row>
      )}
    </Field>
  );
};
